import userApi from '@/api/user';
import _ from 'lodash';
import {
  getToken,
  setToken,
  getRememberedAccount,
  setRememberedAccount
} from '@/store/utils/user';
import router from '@/router';

let token = getToken();

let user = {};

let rememberedAccount = getRememberedAccount();

let userClickBranch = '';

const state = {
  token,
  user,
  rememberedAccount,
  userClickBranch
};

const actions = {
  login({ commit }, { account, password, remember, recaptcha, cb, errCb }) {
    userApi.login(
      { account, password, recaptcha },
      auth => {
        commit('setUser', auth.user);

        commit('setToken', auth.api_token);

        if (remember) {
          commit('setRememberedAccount', account);
        } else {
          commit('setRememberedAccount', '');
        }

        if (cb) {
          cb(auth);
        }
      },
      () => {
        errCb();
      }
    );
  },
  logout({ commit, getters }) {
    const logoutAction = () => {
      commit('setUser', {});

      commit('setToken', '');

      commit('clearUserClickBranch');

      router.push({ name: '首頁' }).catch(() => {});
    };

    if (getters.isLogin) {
      userApi.logout(() => {
        logoutAction();
      });
    } else {
      logoutAction();
    }
  },
  fetchUser({ commit }) {
    userApi.fetchUser(user => {
      commit('setUser', user);
    });
  },
  clearBranch({ commit }) {
    commit('clearUserClickBranch');
  }
};

const mutations = {
  setUser(state, user) {
    state.user = user;
  },
  setToken(state, token) {
    state.token = token;

    setToken(token);
  },
  setRememberedAccount(state, rememberedAccount) {
    state.rememberedAccount = rememberedAccount;

    setRememberedAccount(rememberedAccount);
  },
  setUserClickBranch(state, branchName) {
    localStorage.setItem('branchName', branchName);
    state.userClickBranch = branchName;
  },
  clearUserClickBranch(state) {
    localStorage.removeItem('branchName');
    state.userClickBranch = '';
  }
};

const getters = {
  isLogin(state) {
    return state.token ? true : false;
  },

  // 登入 token
  token(state) {
    return state.token;
  },

  // 登入記住的帳號
  rememberedAccount(state) {
    return state.rememberedAccount;
  },

  // 帳號
  account(state) {
    return _.get(state, 'user.account');
  },

  // 姓名
  name(state) {
    return _.get(state, 'user.name');
  },

  // 分店編號
  branchNo(state) {
    return _.get(state, 'user.branch.no');
  },

  // 分店名稱
  branchName(state) {
    return _.get(state, 'user.branch.name');
  },

  // 分店id
  branchId(state) {
    return _.get(state, 'user.branch.branch_id');
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
